import { IAjaxConfig } from '../helpers';
/**
 *  EnumApiBPmproduct API 地址
 *  @swagger  b2bSystem => http://bpportalsystemsit.earth.xpaas.lenovo.com/swagger-ui.html#/
 */
export class EnumApiProduct {
  /**
   * @dec 获取产品列表
   */
  readonly product_search: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/recommendGoods/search',
    method: 'post',
    body: { source: 'BPPORTAL' },
  };
  /**
   * @dec 获取ISG积分列表
   */
  readonly product_search_ISG: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/integral/product/list',
    method: 'post',
    body: { source: 'BPPORTAL' },
  };
  /**
   * @dec 获取产品列表活动价格
   */
  readonly product_search_price: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/portalProduct/promotionPrice',
    method: 'post',
    body: { source: 'BPPORTAL' },
  };
  /**
   * @dec 获取产品详情
   */
  readonly product_detail: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/product/detail',
    method: 'post',
    loading: true,
    cache: false,
    body: { source: 'BPPORTAL' },
  };
  /**
   * @dec 获取ISG产品详情
   */
  readonly product_detail_ISG: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/integral/product/details',
    method: 'post',
    loading: true,
    cache: false,
    body: { source: 'BPPORTAL' },
  };
  /**
   * @dec 获取产品详情最新价格 根据选择的配件
   */
  readonly product_detail_select: IAjaxConfig = {
    // url: '/api/bpportal-mall/bpportal-mall-product/product/recommendDetailSelect',
    url: '/api/bpportal-mall/bpportal-mall-product/portalProduct/productSelected',
    method: 'post',
    loading: true,
    body: { source: 'BPPORTAL' },
  };
  /**
   * @dec 产品类别类型
   * @method get
   */
  readonly product_category: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/product/getCategory',
    method: 'post',
    cache: true,
    awaitAuthenticated: false,
    body: { code: '01', platform: 'BPPORTAL' },
  };
  /**
   * @dec 产品标签
   * @method get
   */
  readonly product_label: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/product/getLabel',
    method: 'post',
    cache: true,
    awaitAuthenticated: false,
    body: { code: '01', usageType: 0, platformCode: 'BPPORTAL' },
  };

  /**
   * @dec 同系列产品
   * @method post
   */
  readonly product_sameSeries: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/portalProduct/sameSeries',
    method: 'post',
    cache: false,
    awaitAuthenticated: false,
    body: { source: 'BPPORTAL' },
  };

  /**
   * @dec 获取详情页推荐产品
   * @method post
   */
  readonly product_recommend: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/recommend/likelyInDetail',
    cache: false,
    awaitAuthenticated: false,
  };

  /**
   * @dec 详情页推荐产品点击量统计
   * @method post
   */
  readonly product_count: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/bpPortalApi/addProductViewRecord',
    cache: false,
    method: 'post',
    awaitAuthenticated: false,
  };

  /**
   * @dec 详情页推荐产品曝光量统计
   * @method post
   */
  readonly product_show_count: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/recommend/displayLogRecord',
    cache: false,
    method: 'post',
    awaitAuthenticated: false,
  };

  /**
   * @dec 首页-推荐列表
   * {"topNumber": 5}
   */
  readonly product_recommendList: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/bpPortalApi/getTopProducts',
    method: 'post',
    // awaitAuthenticated: false,
    body: { topNumber: 4 },
    // cache: true
  };

  /**
   * @dec 首页-明星产品
   * {"topNumber": 6}
   */
  readonly product_starProducts: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/bpPortalApi/getStarProducts',
    method: 'post',
    // awaitAuthenticated: false,
    body: { topNumber: 6 },
    // cache: true
  };

  /**
   * @dec 个人中心-我的订单 获取订单状态 下拉
   */
  readonly product_orderStatus: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-system/common/combo/{id}',
    cache: true,
  };

  /**
   * @dec 立即预约
   */
  readonly product_reserve: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/createorder/saveReserve',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 购物车角标
   */
  readonly product_cartProductTotalNum: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/cart/getCartProductTotalNum',
    method: 'post',
    loading: false,
  };
  /**
   * @dec 获取渠道产品系列数据
   */
  readonly product_screenList: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-goodsinfomgmt/goodsWeb/goodsCategoriy',
    method: 'post',
    loading: true,
    body: { platform: 'BPPORTAL' },
  };
  /**
   * @dec 获取渠道详情数据
   */
  readonly product_productInfo: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-goodsinfomgmt/goodsWeb/getProductInfoByCode',
    method: 'post',
    loading: true,
    fos: true,
  };

  /**
   * @dec 获取渠道详情产品数据
   */
  readonly product_productList: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-goodsinfomgmt/goodsWeb/recommendSearch',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 获取渠道详情产品TDK数据
   */
  readonly product_productTDK: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-goodsinfomgmt/goodsWeb/getAllParent',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 留言咨询保存接口
   */
  readonly product_advisory: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-goodsinfomgmt/external/officialWebsite/intention/saveIntention',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 留言咨询省份下拉
   */
  readonly product_advisory_province: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-goodsinfomgmt/external/officialWebsite/regionToGet/20029',
    method: 'get',
  };
  /**
   * @dec 留言咨询城市下拉
   */
  readonly product_advisory_city: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-goodsinfomgmt/external/officialWebsite/regionToGet2/{province}/20030',
    method: 'get',
  };
  /**
   * @dec 留言咨询行业下拉
   */
  readonly product_advisory_industry: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-goodsinfomgmt/external/officialWebsite/getAllIndustry',
    method: 'get',
  };
  /**
   * @dec 多渠道BU目录列表
   */
  readonly product_channels_list: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-goodsinfomgmt/sys/menu/mobile/list',
    method: 'get',
    loading: false,
  };
  /**
   * @dec 目录搜索
   * */
  readonly product_channels_search: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-goodsinfomgmt/sys/menu/product/search',
    method: 'post',
    loading: false,
  };

  // 积分产品相关接口

  /**
   * @dec 获取积分产品列表
   */
  readonly product_search_points: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/points-product/l1/list',
    method: 'post',
  };

  /**
   * @dec 获取积分产品详情
   */
  readonly product_detail_points: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-product/points-product/detail/{productId}/{providerRelId}',
    method: 'get',
    loading: true,
    cache: false,
  };
}
